import React from 'react'
import cn from 'classnames'
import styles from './stream-options.module.scss'

export default function StreamAccessOptions({ isPublic, onChange, disabled = false }) {
    return (
        <div className={styles.optionsContainer}>
            <div className={styles.optionsComp}>
                <div className={styles.optionLabel}>Choose Access:</div>

                <div className={styles.optionsContent}>
                    <div
                        className={cn(
                            styles.option,
                            !isPublic && styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange(false)}
                    >
                        <span>
                            <i className="fa fa-lock"></i>
                        </span>{' '}
                        Private
                    </div>

                    <div
                        className={cn(
                            styles.option,
                            isPublic && styles.chosenOption,
                            disabled && styles.disabled,
                        )}
                        onClick={() => !disabled && onChange(true)}
                    >
                        <span>
                            <i className="fa fa-globe"></i>
                        </span>{' '}
                        Public
                    </div>
                </div>
            </div>
        </div>
    )
}
